<div class="container-fluid cookie-modal">
  <div class="header">
    <div class="row py-4 align-items-center border-bottom">
      <div class="col-10">
        <div class="row align-items-center">
          <div class="col-md-2">
            <div class="logo">
              <img src="./../assets/images/logo.png" alt="Logo" class="w-100" />
            </div>
          </div>
          <div class="col-md-8">
            <h3 class="m-0">Privacy Preference Center</h3>
          </div>
        </div>
      </div>
      <div class="col-2 text-right">
        <div class="close-icon">
          <button type="button" (click)="close()" class="bg-transparent"><img src="./../assets/images/creditor-portal/close-icon.svg" alt="Close" /></button>
        </div>
      </div>
    </div>
  </div>   
  <div class="row border-bottom mb-5">
    <div class="col-md-12 px-0">
      <div class="vertical-tab">
        <mat-tab-group mat-align-tabs="start">
          <mat-tab label="Your Privacy">
            <div class="row mt-4">
              <div class="col-md-12">
                <h5>Your Privacy</h5>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <p>
                  When you visit any website, it may store or retrieve information on your browser, mostly in the form of cookies. This information might be about you, your preferences or your device and is mostly used to make the site work as you expect it to. The information does not usually directly identify you, but it can give you a more personalized web experience. Because we respect your right to privacy, you can choose not to allow some types of cookies. Click on the different category headings to find out more and change our default settings. However, blocking some types of cookies may impact your experience of the site and the services we are able to offer.
                  <a href="https://home.kpmg/sg/en/home/misc/privacy.html" target="_blank" class="privacy-link">Privacy Statement</a>
                </p>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="Strictly necessary cookies">
            <div class="row mt-4">
              <div class="col-md-6">
                <h5>Strictly Necessary Cookies</h5>
              </div>
              <div class="col-md-6 text-md-right">
                <h5 class="al-active m-0">Always Active</h5>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <p>
                  These cookies are essential to ensure that the visitor can navigate and use certain functions of the website. Without them, essential parts of the website cannot be used. Accordingly, these cookies are always activated. They are only used when you visit our website and are usually deleted when you close your browser. They are also used to call up the optimised website display when accessed with a mobile device so that, for example, your data volume is not unnecessarily consumed. The cookies also facilitate the page change from http to https, so that the security of the transferred data remains guaranteed.
                </p>
              </div>
            </div>

          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-12 text-md-right">
    <div class="cookie-button-section">
      <button type="button" (click)="proceed()" class="primary-button">AGREE AND PROCEED</button>
    </div>
  </div>
</div>

